import {usePlant} from './usePlant'

export const usePlantId: () => string = () => {
  const plant = usePlant()
  return plant?.id ?? ''
}
